import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';

import LoginPage from './LoginPage';
import CallbackJrUpgPage from './CallbackJrUpgPage';
import CallbackJSUPPage from './CallbackJSUPPage';

import TicketPage from './TicketPage';
import TicketDetailPage from './TicketDetailPage';

import ReserveMachinePage from './ReserveMachinePage';

import PurchaseHistoryPage from './PurchaseHistoryPage';

export default history =>
	combineReducers({
		form: formReducer,
		router: connectRouter(history),
		// Pages
		loginPageReducer: LoginPage,
		callbackJrUpgPageReducer: CallbackJrUpgPage,
		callbackJSUPPageReducer: CallbackJSUPPage,
		ticketPageReducer: TicketPage,
		ticketDetailPageReducer: TicketDetailPage,
		reserveMachinePageReducer: ReserveMachinePage,
		purchaseHistoryPageReducer: PurchaseHistoryPage
	});
